import { takeLatest, put, call, select } from 'redux-saga/effects';
import ApiCall from './ApiCall';
import CaseTransformer from '../../helpers/CaseTransformer';

function* ApiResponse() {
  try {
    const { UserIdData = {}, SelectedCategoriesData = {} } = yield select();
    const { uuid = 0 } = UserIdData;
    const body = CaseTransformer.keysToSnake(SelectedCategoriesData);
    const response = yield call(() =>
      ApiCall('/application/CPCSCategoriesStep', { ...body, uuid }, true)
    );

    yield put({
      type: 'GET_CATEGORIES_DETAILS_FULFILLED',
      payload: {
        data: response.data.data,
      },
    });
    yield put({
      type: 'CHANGE_SCREEN',
      payload: {
        link: '/applicant-details',
        form: 'applicant-details',
      },
    });
  } catch (e) {
    yield put({
      type: 'API_REJECTED',
      payload: e.response.data,
    });
    yield put({
      type: 'DISABLE_SPINNER',
      payload: e.response.data,
    });
    yield put({
      type: 'CANCEL_SUBMIT',
      payload: e.response.data,
    });
  }
}
function* watchLastFetchUser() {
  yield takeLatest('GET_CATEGORIES_DATA', ApiResponse);
}

export default watchLastFetchUser;
